import { lazy } from "react";
import Login from "../Views/Auth/Login";
import PublicAuth from "./PublicAuth";
import SingleOrGroup from "../Views/Main/MakeOrder/SingleOrGroup";
import MakeOrderByCutomer from "../Views/Main/MakeOrder/MakeOrderByCutomer";
import ForgotPassword from "../Views/Auth/ForgotPassword";
import Register from "../Views/Auth/Register";
// const MakeOrder = lazy(() => import("../Views/Main/MakeOrder/MakeOrder"));


export const PublicRoutes = () => {
  return [
    {
      element: <PublicAuth />,


      children: [
        {
          path: "/",
          element: <Login />,
        },
        {
          path: "/forgot-password",
          element: <ForgotPassword />,
        },
        {
          path: "/register",
          element: <Register />,
        },
        {
          path: "/order-by-customer",
          element: <MakeOrderByCutomer/>,
        },
        {
          path: "/single-or-group",
          element: <SingleOrGroup />,
        },
      ],
    },
  ];
};
